


















































// @ is an alias to /src
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import {namespace} from "vuex-class";

  import {ops} from "@/constants/vueScrollConfig";
  import DroppoOptionsButton from '@/views/components/Home/DroppoOptionsButton.vue';
  import {
    AMAZON_RETURNS_ROUTES,
    CLICK_AND_COLLECT_CORTE_INGLES_ROUTES,
    CLICK_AND_COLLECT_ROUTES,
    CROSS_TOWN_ROUTES,
  } from "@/constants/routes";
  import {pwaInstallerService} from "@/services/services";
  import {ANALYTIC_CLICKS} from "@/services/Analytics";
  import {IUserData} from "@/models/ApiModels";
  import {Config} from "vuescroll";
  import {DISPLAY_MODE} from "@/constants/system";

  const userDataModule = namespace("userData");
  const systemModule = namespace("system");

  @Component({
    name: 'HomeContent',
    components: {
      DroppoOptionsButton,
    },
  })
  export default class HomeContent extends Vue {
    @userDataModule.Getter("getProfile")
    private user!: IUserData;


    @systemModule.Getter("getCanInstall")
    private getCanInstall!: boolean;

    @systemModule.Getter("getIsInstalled")
    private getIsInstalled!: boolean;

    @systemModule.Getter("getDisplayMode")
    private getDisplayMode!: DISPLAY_MODE;

    @systemModule.Getter("isRunningInStandaloneMode")
    private isRunningInStandaloneMode!: boolean;

    @systemModule.Getter("showInstallButton")
    private showInstallButton!: boolean;


    @systemModule.Action("setCanInstall")
    private setCanInstall!: boolean;

    @systemModule.Action("setIsInstalled")
    private setIsInstalled!: boolean;

    @systemModule.Action("setDisplayMode")
    private setDisplayMode!: boolean;

    private readonly ops: Config = ops;

    private coSaved: number = 4000;

    private CROSS_TOWN_ROUTES = CROSS_TOWN_ROUTES;

    private updateCoSaved() {
      this.coSaved = this.coSaved + 10;
    }

    private installApp() {
      ANALYTIC_CLICKS.installApp(this.$gtag);
      pwaInstallerService.install();
    }

    private goToView(to: string) {
      this.$router.push({ name: to});
    }

    private goToClickCollect() {
      ANALYTIC_CLICKS.clickCollectPackages(this.$gtag);
      this.goToView(CLICK_AND_COLLECT_ROUTES.START);
    }

    private goToClickCollectCI() {
      ANALYTIC_CLICKS.clickCollectCIPackages(this.$gtag);
      this.goToView(CLICK_AND_COLLECT_CORTE_INGLES_ROUTES.START);
    }

    private goExternal() {
      ANALYTIC_CLICKS.receivePackages(this.$gtag);
      this.$uiBus.emit('dialog:external:show');
    }

    private goCrossTown() {
      ANALYTIC_CLICKS.crossTown(this.$gtag);
      this.goToView(CROSS_TOWN_ROUTES.START);
    }

    private goReturns() {
      ANALYTIC_CLICKS.returns(this.$gtag);
      this.goToView(AMAZON_RETURNS_ROUTES.START);
    }

  }
